import { render, staticRenderFns } from "./DetialList.vue?vue&type=template&id=d8088824&scoped=true"
import script from "./DetialList.vue?vue&type=script&lang=js"
export * from "./DetialList.vue?vue&type=script&lang=js"
import style0 from "./DetialList.vue?vue&type=style&index=0&id=d8088824&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8088824",
  null
  
)

export default component.exports